Turbo.StreamActions.add_class = function () {
  const target = document.getElementById(this.getAttribute('target'));
  if (target) {
    target.classList.add(this.getAttribute('value'));
  }
};

Turbo.StreamActions.remove_class = function () {
  const target = document.getElementById(this.getAttribute('target'));
  if (target) {
    target.classList.remove(this.getAttribute('value'));
  }
};
